__turbopack_context__.v({
  "rating": "Rating-module-sass-module__9wDHLa__rating",
});
